import { range } from 'ramda'

import { Beneficiary } from 'generated/types'
import { USDFormatter } from 'utils/number/currency'

import { RecurringSettingsForBeneficiary } from './types'

export const INELEGIBLE_EARLY_STATES = [
  'Armed Forces America',
  'Puerto Rico',
  'American Samoa',
  'Northern Mariana Islands',
]

// sorts by account setup completion, age, and then firstName.
const compareFunction = (a, b) => {
  if (a.investmentAccount && !b.investmentAccount) {
    return 1
  }
  if (!a.investmentAccount && b.investmentAccount) {
    return -1
  }
  if (a.age - b.age <= -1) {
    return 1
  }
  if (a.age - b.age >= 1) {
    return -1
  }
  return a.firstName.localeCompare(b.firstName)
}

export const sortEarlyAccounts = (accounts) => {
  return accounts.sort(compareFunction)
}

export const sumEarlyBalances = (earlyAccounts) => {
  let total = 0

  earlyAccounts.map((earlyAccount) => {
    total =
      total + (earlyAccount?.investmentAccount?.currentBalance?.value || 0)
  })
  return USDFormatter.format(total)
}

export const getBeneficiaryByLocation = (
  beneficiaries: Beneficiary[] | RecurringSettingsForBeneficiary[],
  routeParameters: { beneficiaryId?: string; [key: string]: any },
) => {
  const relevantBeneficiary =
    beneficiaries.find(
      (beneficiary) => beneficiary.id === routeParameters.beneficiaryId,
    ) ?? null

  return relevantBeneficiary as
    | Beneficiary
    | RecurringSettingsForBeneficiary
    | null
}

export const calculateTransferYear = (age: number, ageOfTransfer: number) => {
  const currentDate = new Date()
  return currentDate.getUTCFullYear() - age + ageOfTransfer
}

export const generateAgeOfTransferOptions = (
  minAge: number,
  maxAge: number,
) => {
  const possibleAgesOfTransfer = range(minAge, maxAge + 1)

  return possibleAgesOfTransfer.map((age) => {
    const value = age.toString()
    return {
      label: value,
      value,
    }
  })
}
